export default __webpack_public_path__ + "static/media/grafema_angura_09.a451b45b.jpg";